import React, { createContext, useEffect, useState } from 'react'

import { merge } from 'lodash'

import { MatxLayoutSettings } from 'app/components/MatxLayout/settings'

const SettingsContext = createContext({
    settings: MatxLayoutSettings,
    updateSettings: () => {},
})

const STORAGE_KEY = 'matx_settings'

const normalizeSettings = (s = MatxLayoutSettings) => {
    const next = merge({}, MatxLayoutSettings, s)
    if (!next.layout1Settings) next.layout1Settings = {}
    if (!next.layout1Settings.leftSidebar) next.layout1Settings.leftSidebar = {}
    next.layout1Settings.leftSidebar.show = true
    // В хранилище оставляем только десктопные режимы
    if (!next.layout1Settings.leftSidebar.mode) {
        next.layout1Settings.leftSidebar.mode = 'full'
    }
    if (
        next.layout1Settings.leftSidebar.mode === 'close' ||
        next.layout1Settings.leftSidebar.mode === 'mobile'
    ) {
        next.layout1Settings.leftSidebar.mode = 'compact'
    }
    return next
}

export const SettingsProvider = ({ settings, children }) => {
    const getInitialSettings = () => {
        if (settings) return settings
        try {
            const saved = localStorage.getItem(STORAGE_KEY)
            if (saved) {
                return normalizeSettings(JSON.parse(saved))
            }
        } catch (err) {
            console.error('Settings load error', err)
        }
        return normalizeSettings(MatxLayoutSettings)
    }

    const [currentSettings, setCurrentSettings] = useState(getInitialSettings)

    const handleUpdateSettings = (update = {}) => {
        setCurrentSettings((prev) => merge({}, prev, update))
    }

    useEffect(() => {
        try {
            const toSave = normalizeSettings(currentSettings)
            localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave))
        } catch (err) {
            console.error('Settings save error', err)
        }
    }, [currentSettings])

    return (
        <SettingsContext.Provider
            value={{
                settings: currentSettings,
                updateSettings: handleUpdateSettings,
            }}
        >
            {children}
        </SettingsContext.Provider>
    )
}

export default SettingsContext
